export default {
  'menu.companyStaffListPage': '从业人员列表',
  'app.companyStaffPage.attr.gender.enum.male': '男性',
  'app.companyStaffPage.attr.gender.enum.female': '女性',
  'app.companyStaffPage.attr.gender.enum.other': '其他',
}